import { editContentConfig } from "./editContentConfig";
import { EducationType } from "../../../school/constants/types";

export const validator = async ({ values }) => {
  const errors: { [key: string]: any } = { applicationFiles: {} };
  const stepName: string = editContentConfig.stepName!;

  const educationType = values.injectedData.educationType;

  if (
    (educationType === EducationType.Higher ||
      educationType === EducationType.Secondary) &&
    values.injectedData.program.academic.applicationLink &&
    !values[stepName].isLinkConfirmed
  ) {
    errors.isLinkConfirmed = "Confirmation is required";
  }

  if (
    educationType === EducationType.Language &&
    values.injectedData.course.applicationLink &&
    !values[stepName].isLinkConfirmed
  ) {
    errors.isLinkConfirmed = "Confirmation is required";
  }

  if (
    (educationType === EducationType.Higher ||
      educationType === EducationType.Secondary) &&
    !values[stepName].intake
  ) {
    errors.intake = "Intake is required";
  }

  values.injectedData.filledForms.forEach((form) => {
    if (
      !form.filled &&
      !values[stepName]?.applicationFiles?.hasOwnProperty(form.received.id)
    ) {
      errors.applicationFiles[form.received.id] = "File is required";
    }
  });

  if (
    Object.keys(errors).length > 1 ||
    Object.keys(errors.applicationFiles).length > 0
  ) {
    throw {
      [stepName]: errors,
    };
  }
};
